import React from "react";
import UserDetailsHeader from "../../../../UserDetailsHeader";
import { Typography } from "@mui/material";
import videothumbnailIcon from "../../../../../../assets/images/HowtoTestVideoThumbnail.svg";
import "../../howToTest/howToTest.scss";
import prerequisitesImg from "../../../../../../assets/images/HowToTest/TugFront/prerequistes.png";
import setupImg from "../../../../../../assets/images/HowToTest/TugFront/setup.png";
import performTestImg from "../../../../../../assets/images/HowToTest/TugFront/performTest.png";
import uploadImg from "../../../../../../assets/images/HowToTest/TugFront/upload.png";
import setupForJP from "../../../../../../assets/images/HowToTest/TugFront/setupForJP.png";
import uploadForJP from "../../../../../../assets/images/HowToTest/TugFront/uploadForJP.png";
import { useSection } from "../../../../../../i18n/useSection";
import { useLocale } from "../../../../../../i18n/I18nProvider";
import { getModuleName } from "../../../../../../utlis/measurementModuleLabels";

const HowtoTestTugFront = () => {
  // Japanese-captioned videos/images only for the Japanese UI; every other
  // language gets the English assets.
  const { locale } = useLocale();
  const isJapanese = locale === "ja";
  const {
    armless_chair_desc,
    phone_stand_desc,
    support_desc,
    setup1,
    setup2,
    setup3,
    setup4,
    perform1,
    perform2,
    perform3,
    upload1,
    upload2,
    setupnewAdd,
    guide_title,
  } = useSection("tugFront");
  const {
    how_to,
    playlist,
    test_guide,
    support_person_guidelines,
    general_guide,
    armless_chair,
    phone_stand,
    support_person,
    step_guide,
    step_one,
    step_two,
    step_three,
    step_four,
    disable_wide,
    disable_wide_desc,
  } = useSection("common");
  const videoPlayHandler = (link) => {
    window.open(link, "_blank");
  };
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const playlistItem = [
    {
      title: `1. ${test_guide}`,
      urlEN: `https://youtu.be/x4J2ZFBNSu8`,
      urlJP: `https://youtu.be/xo2AbpOl-F0`,
    },
    {
      title: `2. ${support_person_guidelines}`,
      urlEN: `https://youtu.be/jdexqsfzGQA`,
      urlJP: `https://youtu.be/FMdKekBExPE`,
    },
    {
      title: `3. ${general_guide}`,
      urlEN: `https://youtu.be/Qb3T992cBRg`,
      urlJP: `https://youtu.be/O3FCaxYYFN0`,
    },
  ];
  const prerequisitesStepsItem = [
    {
      title: armless_chair,
      description: armless_chair_desc,
    },
    {
      title: phone_stand,
      description: phone_stand_desc,
    },
    {
      title: support_person,
      description: support_desc,
    },
    {
      title: disable_wide,
      description: disable_wide_desc,
    },
  ];
  return (
    <>
      <UserDetailsHeader>
        <div className="how-to-test-main-wrapper measurement-guide">
          <Typography className="title">
            {guide_title || `${getModuleName(getInfo)}: ${how_to}`}
          </Typography>
          <div className="test-instruction-wrapper">
            <Typography className="test-instruction-title">
              {playlist}
            </Typography>
            {playlistItem?.map((item, index) => {
              return (
                <div
                  className="video-playlist"
                  key={index}
                  onClick={() =>
                    videoPlayHandler(isJapanese ? item.urlJP : item.urlEN)
                  }
                >
                  <div>
                    <img src={videothumbnailIcon} alt="thumbnail" />
                  </div>
                  <div>
                    <Typography>{item.title}</Typography>
                  </div>
                </div>
              );
            })}
            <Typography className="test-instruction-title">
              {step_guide}
            </Typography>
            <div className="steps-one">
              <Typography className="test-instruction-title">
                1. {step_one}
              </Typography>
              <img
                src={prerequisitesImg}
                alt="prerequisites"
                className="img one"
              />
              {prerequisitesStepsItem?.map((item, index) => {
                return (
                  <div className="prerequisites-step" key={index}>
                    <Typography className="step-title">{item.title}</Typography>
                    <Typography className="description">
                      {item.description}
                    </Typography>
                  </div>
                );
              })}
              <div className="test-step-divider"></div>
            </div>
            <div className="step-two">
              <Typography className="test-instruction-title">
                2. {step_two}
              </Typography>
              {!isJapanese ? (
                <img src={setupImg} alt="steup" className="img" />
              ) : (
                <img src={setupForJP} alt="steup" className="img" />
              )}
              <ul className="list-instruction">
                <li>{setup1}</li>
                <li dangerouslySetInnerHTML={{ __html: setup2 }}></li>
                <li dangerouslySetInnerHTML={{ __html: setup3 }}></li>
                <li dangerouslySetInnerHTML={{ __html: setupnewAdd }}></li>
                <li dangerouslySetInnerHTML={{ __html: setup4 }}></li>
              </ul>
              <div className="test-step-divider"></div>
            </div>
            <div className="step-three">
              <Typography className="test-instruction-title">
                3. {step_three}
              </Typography>
              <img src={performTestImg} alt="perform-test" className="img" />
              <ul className="list-instruction">
                <li>{perform1}</li>
                <li dangerouslySetInnerHTML={{ __html: perform2 }}></li>
                <li>{perform3}</li>
              </ul>
              <div className="test-step-divider"></div>
            </div>
            <div className="step-four">
              <Typography className="test-instruction-title">
                4. {step_four}
              </Typography>
              {!isJapanese ? (
                <img src={uploadImg} alt="steup" className="img" />
              ) : (
                <img src={uploadForJP} alt="steup" className="img" />
              )}
              <ul className="list-instruction">
                <li dangerouslySetInnerHTML={{ __html: upload1 }}></li>
                <li dangerouslySetInnerHTML={{ __html: upload2 }}></li>
              </ul>
            </div>
          </div>
        </div>
      </UserDetailsHeader>
    </>
  );
};

export default HowtoTestTugFront;
